<ul>
  <ng-container *ngFor="let item of vm.menuItems()">
    <div *ngIf="item.type === menuItemType.Single">
      <li *appRequirePermission="item.permission">
        <a
          [ngClass]="{ link: true, selected: vm.expandedItem()?.text === item.text }"
          [routerLink]="item.link"
          routerLinkActive="active"
          (click)="selectedItem$.next(item)"
          [appDisabled]="!item.isAvailableWhileOffline && vm.offlineIsActive()"
        >
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.text }}</span>
        </a>
      </li>
    </div>
    <div *ngIf="item.type === menuItemType.Section">
      <li *appRequirePermission="item.permission">
        <a
          [ngClass]="{ link: true, selected: vm.expandedItem()?.text === item.text }"
          [routerLink]="undefined"
          routerLinkActive="active"
          (click)="
            selectedItem$.next(
              vm.expandedItem()?.text === item.text && vm.activeItem()?.text !== item.text
                ? null
                : item
            )
          "
        >
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.text }}</span>
          <span
            [ngClass]="{ toggle: true, expanded: vm.expandedItem()?.text === item.text }"
            style="margin-left: auto"
          >
            <mat-icon>expand_more</mat-icon>
          </span>
        </a>

        <div class="wrapper" [ngClass]="{ show: vm.expandedItem()?.text === item.text }">
          <ul *ngIf="item.subsections?.length">
            <ng-container *ngFor="let sub of item.subsections">
              <ng-container *ngIf="sub.permission; else withoutPermission">
                <li *appRequirePermission="sub.permission">
                  <a
                    class="sub-link"
                    [routerLink]="sub.link"
                    routerLinkActive="active"
                    [appDisabled]="!item.isAvailableWhileOffline && vm.offlineIsActive()"
                  >
                    <span>{{ sub.text }}</span>
                  </a>
                </li>
              </ng-container>
              <ng-template #withoutPermission>
                <li>
                  <a
                    class="sub-link"
                    [routerLink]="sub.link"
                    routerLinkActive="active"
                    [appDisabled]="!item.isAvailableWhileOffline && vm.offlineIsActive()"
                  >
                    <span>{{ sub.text }}</span>
                  </a>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </div>
      </li>
    </div>
  </ng-container>
</ul>
